const namespace = {
  tabs: {
    commute: "Transport",
    amenities: "Services",
    character: "Caractère",
    nature: "Nature",
    education: "Familles",
    wellness: "Bien-être",
  },
  results: {
    none: "Désolé, il n'y a pas de résultats pour cette recherche dans le rayon spécifié autour de l'emplacement sélectionné.",
    limited: "Résultats limités pour cette recherche dans un rayon de",
  },
  commuteCalculator: {
    type: {
      pedestrian: "En marchant",
      car: "En conduisant",
    },
    placeholder: "Faire une recherche...",
    cta: "Calculer le trajet",
    ctaShort: "Calculer",
    results: {
      noRoute: "Aucun itinéraire disponible.",
      trySuggestion: "Essayez une autre requête.",
      fastestRoute: "Itinéraire le plus rapide",
    },
  },
  scores: {
    location: "Ce Lieu",
    average: "{{type}} Moy.",
    city: "Ville",
    neighborhood: "Quartier",
  },
} as const;

export default namespace;
